import { useQuery } from '@tanstack/react-query';
import { getFilterCommercialHierarchy } from 'services/api/requests/market';

export const useGetFilterCommercialHierarchy = canalVendaId => {
	return useQuery(
		['commercialHierarchy-list', canalVendaId],
		getFilterCommercialHierarchy,
		{
			refetchOnWindowFocus: false,
		}
	);
};
